<template>
	<div id="app">
		<router-view v-if="isRouterAlive"/>
		<div class="mask" v-show="is_loading">
			<div class="loading"></div>
		</div>
	</div>
</template>

<script>
	import Menu from '@/components/common/menu'
	import { mapState } from 'vuex'
	export default {
		components: { //局部注册导航菜单组件
			Menu
		},
		computed: mapState({
			is_loading: state => state.is_loading,
		}),
		provide() { //提供reload方法
    		return {
   				reload: this.reload
    		}
		},
		data(){
			return {
				menu_list:[],
				isRouterAlive : true
			}
		},
		methods: {
			init() {
				this.getMenu();
			},
			getMenu() {
				this.$axios.get('/static/js/menu.json', {
					baseURL: "/"
				}).then((data) => {
					if(data && data.length > 0) {
						this.menu_list = data;
					}
				});
			},
			reload() { //页面重载
				this.isRouterAlive = false;
				this.$nextTick(function() {
					this.isRouterAlive = true
				})
			},
		},
		mounted() {
//			this.init();
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/view/main.vue